/* fc-pp-multi-compare.js (2026-10-12 speed pass): the compare table (iPhone Duo mode, dropdown picks, swipe hint, view more, bezel).
   Moved out of sections/fc-pp-multi-compare.liquid so browsers cache it across product
   pages; the root is #fc-mcmp and per-instance values travel as data
   attributes (or the JSON config script). The bodies are the former inline
   scripts, unchanged apart from those lookups. Re-initialises on
   shopify:section:load for the theme editor. */
(function () {
  'use strict';
  function initCompare(root) {

  var table = root.querySelector('[data-fc-mcmp-table]');
  var bezel = root.querySelector('[data-fc-mcmp-bezel]');
  var cols = Array.prototype.slice.call(root.querySelectorAll('[data-fc-mcmp-col]'));
  if (!table) return;


  // ---------- iPhone Duo mode (2026-09-11) ----------
  var currentDev = root.getAttribute('data-fc-mcmp-device') || 'galaxy';
  var UNAVAIL = root.getAttribute('data-fc-unavail') || 'Coming soon for iPhone Duo';
  function swapMedia(col, imgSrc, imgAlt, priceHtml, url) {
    var media = col.querySelector('[data-fc-mcmp-media]');
    var img = media ? media.querySelector('img') : null;
    var price = col.querySelector('[data-fc-mcmp-price]');
    var view = col.querySelector('[data-fc-mcmp-view]');
    if (img && imgSrc && img.getAttribute('src') !== imgSrc) {
      media.classList.add('is-swapping');
      setTimeout(function() { img.src = imgSrc; if (imgAlt) img.alt = imgAlt; media.classList.remove('is-swapping'); }, 120);
    }
    if (media && url) media.setAttribute('href', url);
    if (price && priceHtml != null) price.innerHTML = priceHtml;
    if (view && url) view.setAttribute('href', url);
  }
  function setUnavailable(col, on) {
    var name = col.querySelector('[data-fc-mcmp-name]');
    var price = col.querySelector('[data-fc-mcmp-price]');
    if (on) {
      if (name && !name.hasAttribute('data-name-restore')) name.setAttribute('data-name-restore', name.textContent);
      if (name) name.textContent = UNAVAIL;
      if (price) { if (!price.hasAttribute('data-price-restore')) price.setAttribute('data-price-restore', price.innerHTML); price.innerHTML = ''; }
    } else {
      if (name && name.hasAttribute('data-name-restore')) { name.textContent = name.getAttribute('data-name-restore'); name.removeAttribute('data-name-restore'); }
      if (price && price.hasAttribute('data-price-restore')) { price.innerHTML = price.getAttribute('data-price-restore'); price.removeAttribute('data-price-restore'); }
    }
    col.classList.toggle('is-unavailable', !!on);
  }
  function applyPick(pick, dev) {
    var col = pick.closest('[data-fc-mcmp-col]');
    if (!col) return;
    var duo = dev === 'iphone' && pick.getAttribute('data-fc-duo') === 'true';
    var imgSrc = (duo && pick.getAttribute('data-img-duo')) || pick.getAttribute('data-img') || '';
    var priceHtml = (duo && pick.getAttribute('data-price-html-duo')) || pick.getAttribute('data-price-html') || '';
    var url = (duo && pick.getAttribute('data-url-duo')) || pick.getAttribute('data-url') || '';
    setUnavailable(col, false);
    swapMedia(col, imgSrc, pick.getAttribute('data-img-alt') || '', priceHtml, url);
    var name = col.querySelector('[data-fc-mcmp-name]');
    var swatches = col.querySelector('[data-fc-mcmp-swatches]');
    if (name) name.textContent = pick.getAttribute('data-name') || '';
    if (swatches) swatches.innerHTML = pick.getAttribute('data-swatches-html') || '';
    Array.prototype.forEach.call(col.querySelectorAll('[data-fc-mcmp-pick]'), function(it) {
      it.classList.remove('is-active');
      it.setAttribute('aria-selected', 'false');
    });
    pick.classList.add('is-active');
    pick.setAttribute('aria-selected', 'true');
  }
  function applyDevice(dev) {
    currentDev = dev;
    root.setAttribute('data-fc-mcmp-device', dev);
    cols.forEach(function(col) {
      var items = Array.prototype.slice.call(col.querySelectorAll('[data-fc-mcmp-pick]'));
      var iphone = dev === 'iphone';
      var firstDuo = null;
      items.forEach(function(it) {
        var ok = it.getAttribute('data-fc-duo') === 'true';
        it.hidden = iphone && !ok;
        if (ok && !firstDuo) firstDuo = it;
        var th = it.querySelector('.fc-mcmp-dropitem__thumb img');
        var thSrc = iphone ? (it.getAttribute('data-thumb-duo') || it.getAttribute('data-thumb')) : it.getAttribute('data-thumb');
        if (th && thSrc) th.src = thSrc;
        var pr = it.querySelector('.fc-mcmp-dropitem__price');
        var prHtml = iphone ? (it.getAttribute('data-price-html-duo') || it.getAttribute('data-price-html')) : it.getAttribute('data-price-html');
        if (pr && prHtml) pr.innerHTML = prHtml;
      });
      if (items.length) {
        var active = col.querySelector('[data-fc-mcmp-pick].is-active') || items[0];
        if (iphone) {
          if (active.getAttribute('data-fc-duo') === 'true') applyPick(active, 'iphone');
          else if (firstDuo) applyPick(firstDuo, 'iphone');
          else setUnavailable(col, true);
        } else {
          applyPick(active, 'galaxy');
        }
      } else {
        // Column 1 = the product on this page.
        if (iphone) {
          if (col.getAttribute('data-fc-duo') === 'true') {
            setUnavailable(col, false);
            swapMedia(col, col.getAttribute('data-img-duo'), '', col.getAttribute('data-price-html-duo'), col.getAttribute('data-url-duo'));
          } else setUnavailable(col, true);
        } else {
          setUnavailable(col, false);
          swapMedia(col, col.getAttribute('data-img-galaxy'), '', col.getAttribute('data-price-html-galaxy'), col.getAttribute('data-url-galaxy'));
        }
      }
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-fc-fits]'), function(cell, i) {
      var col = cols[i];
      if (dev === 'iphone') cell.textContent = (col && !col.classList.contains('is-unavailable')) ? (cell.getAttribute('data-fits-duo') || 'iPhone Duo') : '—';
      else cell.textContent = cell.getAttribute('data-fits-galaxy') || '—';
    });
  }
  document.addEventListener('fc:variant:change', function(e) {
    var d = e && e.detail;
    if (!d || !d.variant || !d.variant.options) return;
    if (d.productId && String(d.productId) !== String(root.getAttribute('data-fc-pid'))) return;
    var mi = (window.__fcpp && typeof window.__fcpp.modelIdx === 'number') ? window.__fcpp.modelIdx : -1;
    if (mi < 0) return;
    var dev = /iphone/i.test(String(d.variant.options[mi] || '')) ? 'iphone' : 'galaxy';
    if (dev !== currentDev) applyDevice(dev);
  });
  if (currentDev === 'iphone') applyDevice('iphone');

  // ---------- Dropdown: pill toggle + product swap ----------
  function closeAllDropdowns() {
    cols.forEach(function(col) {
      col.classList.remove('is-open');
      var btn = col.querySelector('[data-fc-mcmp-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  root.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-fc-mcmp-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      var col = toggle.closest('[data-fc-mcmp-col]');
      if (!col) return;
      var dropdown = col.querySelector('[data-fc-mcmp-dropdown]');
      if (!dropdown) return; // No dropdown for this column (no collection)
      var wasOpen = col.classList.contains('is-open');
      closeAllDropdowns();
      if (!wasOpen) {
        col.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    var pick = e.target.closest('[data-fc-mcmp-pick]');
    if (pick) {
      e.preventDefault();
      applyPick(pick, currentDev);
      closeAllDropdowns();
      return;
    }

    // Click outside any open dropdown — close all.
    if (!e.target.closest('[data-fc-mcmp-dropdown]')) {
      closeAllDropdowns();
    }
  });

  // ---------- Mobile swipe hint — fade out when scrolled to end ----------
  var swipeHint = root.querySelector('[data-fc-mcmp-swipe]');
  if (swipeHint && table) {
    function updateSwipeHint() {
      var max = table.scrollWidth - table.clientWidth;
      var atEnd = max <= 4 || table.scrollLeft >= max - 4;
      swipeHint.classList.toggle('is-end', atEnd);
    }
    table.addEventListener('scroll', updateSwipeHint, { passive: true });
    window.addEventListener('resize', updateSwipeHint);
    updateSwipeHint();
  }

  // ---------- View More expand / collapse ----------
  var moreBtn = root.querySelector('[data-fc-mcmp-more]');
  var extraWrap = root.querySelector('[data-fc-mcmp-extra]');
  var moreText = root.querySelector('[data-fc-mcmp-more-text]');
  if (moreBtn && extraWrap) {
    moreBtn.addEventListener('click', function() {
      var willOpen = !extraWrap.classList.contains('is-open');
      extraWrap.classList.toggle('is-open', willOpen);
      moreBtn.classList.toggle('is-expanded', willOpen);
      moreBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (moreText) moreText.textContent = willOpen ? (moreText.getAttribute('data-less') || 'View Less Information') : (moreText.getAttribute('data-more') || 'View More Information');
    });
  }

  // Close on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeAllDropdowns();
  });

  // ---------- Mouse-following bezel (desktop only) ----------
  var DESKTOP_MIN = 769;
  var lastIdx = -1;

  function moveBezelToColumn(idx) {
    if (window.innerWidth < DESKTOP_MIN) {
      bezel.style.opacity = '0';
      lastIdx = -1;
      return;
    }
    var col = cols[idx];
    if (!col) return;
    var tableRect = table.getBoundingClientRect();
    var colRect = col.getBoundingClientRect();
    var left = colRect.left - tableRect.left;
    var width = colRect.width;
    bezel.style.transform = 'translateX(' + left + 'px)';
    bezel.style.width = width + 'px';
    bezel.style.opacity = '1';
    lastIdx = idx;
  }

  table.addEventListener('mousemove', function(e) {
    if (window.innerWidth < DESKTOP_MIN) {
      bezel.style.opacity = '0';
      return;
    }
    var colCount = cols.length || 4;
    var rect = table.getBoundingClientRect();
    var x = e.clientX - rect.left;
    var colWidth = rect.width / colCount;
    var idx = Math.max(0, Math.min(colCount - 1, Math.floor(x / colWidth)));
    if (idx !== lastIdx) moveBezelToColumn(idx);
  });

  table.addEventListener('mouseleave', function() {
    bezel.style.opacity = '0';
    lastIdx = -1;
  });

  window.addEventListener('resize', function() {
    if (lastIdx >= 0) moveBezelToColumn(lastIdx);
  });
  }
  function init() {
    var root = document.getElementById('fc-mcmp');
    if (!root || root.getAttribute('data-fc-init') === '1') return;
    root.setAttribute('data-fc-init', '1');
    initCompare(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#fc-mcmp')) init();
  });
})();
